<template>
  <GenericDialog :activator="activator" @close="emit('close')" small>
    <v-card-title> {{ title }} </v-card-title>
    <v-card-subtitle>Premium feature</v-card-subtitle>
    <v-card-text>
      Please contact PowerTrip to discuss unlocking premium features
    </v-card-text>
  </GenericDialog>
</template>

<script setup lang="ts">
import GenericDialog from "./GenericDialog.vue";

withDefaults(
  defineProps<{
    activator: boolean;
    /** Heading shown above "Premium feature" - the specific action being upsold. */
    title?: string;
  }>(),
  { title: "Book fleet vehicles" },
);

const emit = defineEmits<{ close: [] }>();
</script>
